
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "8979ca2b3efe73f6c331339d4eaa8a19dc59b31e",
  "nuxt": {
    "buildId": "942e7664-00e4-4e8e-841a-699f4438ee24"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
